<span
    class="app-btn-wrapper"
    [matTooltip]="tooltip()"
    [matTooltipDisabled]="isTooltipDisabled()">
    <button
        #btn
        class="app-btn"
        type="button"
        [attr.data-type]="type()"
        [attr.type]="htmlType()"
        [class]="customClass()"
        [class.w-full]="fullWidth()"
        [disabled]="isDisabled()"
        [matMenuTriggerFor]="matMenuTriggerFor() ?? null"
        (click)="handleClick()"
        (menuClosed)="menuClosed.emit()"
        (menuOpened)="menuOpened.emit()">
        @if (loading()) {
            <mat-spinner
                class="shrink-0 app-btn-spinner"
                [diameter]="spinnerSize()" />
        } @else {
            @if ((icon() || stackIcon()) && iconPosition() === IconPosition.START) {
                <ng-container *ngTemplateOutlet="buttonIcon" />
            }

            @if (label()) {
                <span class="button-label-style truncate">{{ label() }}</span>
            }

            @if ((icon() || stackIcon()) && iconPosition() === IconPosition.END) {
                <ng-container *ngTemplateOutlet="buttonIcon" />
            }
        }
    </button>
</span>

<ng-template #buttonIcon>
    @if (stackIcon(); as stack) {
        <app-stack-icons
            class="button-label-style shrink-0"
            [baseIcon]="stack.baseIcon"
            [baseIconClass]="stack.baseIconClass"
            [baseIconTransform]="stack.baseIconTransform"
            [size]="iconSize()"
            [topIcon]="stack.topIcon"
            [topIconClass]="stack.topIconClass"
            [topIconTransform]="stack.topIconTransform" />
    } @else if (icon()) {
        <fa-icon
            class="button-label-style shrink-0"
            [icon]="icon()!"
            [size]="iconSize()"
            [style.color]="iconColor()" />
    }
</ng-template>
